var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPruff9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 53,
    viewBox: "0 0 185 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125.675 17.266H130.366V14.5469C130.366 4.41846 135.6 0 144.233 0C145.66 0 147.292 0.135951 148.923 0.407857V9.38074H146C141.718 9.38074 140.834 11.624 140.834 14.5469V17.266H153.342V14.5469C153.342 4.41846 158.576 0 167.209 0C168.636 0 170.268 0.135951 171.899 0.407857V9.38074H168.976C164.694 9.38074 163.81 11.624 163.81 14.5469V17.266H171.899V25.967H163.81V51.2542H153.342V25.967H140.834V51.2542H130.366V25.967H125.675V17.266Z",
    fill: "#191919"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110.546 17.2659H121.015V51.2541H111.158L110.478 47.4474C108.371 50.2344 104.157 52.1378 100.078 52.1378C92.3287 52.1378 87.5703 46.9715 87.5703 38.6105V17.2659H98.0387V34.8038C98.0387 40.3778 99.942 42.825 104.225 42.825C108.711 42.825 110.546 40.5138 110.546 34.9397V17.2659Z",
    fill: "#191919"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6844 17.2659V27.1225H79.3536C73.3716 27.1225 69.7689 29.7735 69.7689 36.5032V51.2541H59.3005V17.3339H69.1571L69.7009 22.3641C71.1284 19.0333 74.1194 16.79 78.6738 16.79C79.8974 16.79 81.2569 16.926 82.6844 17.2659Z",
    fill: "#191919"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1276 34.5318H36.5083C46.7728 34.5318 53.6384 27.8022 53.6384 17.7417C53.6384 7.68113 46.7728 0.951538 36.5083 0.951538H21.5535C18.5502 0.951538 16.1154 3.38631 16.1154 6.38965V24.7361H0.0521988L-0.00170898 34.4921H16.1154V51.2541H27.1276V34.5318ZM27.1276 10.7401H34.0612C39.3634 10.7401 42.0144 13.0514 42.0144 17.7417C42.0144 22.4321 39.3634 24.7433 34.0612 24.7433H27.1276V10.7401Z",
    fill: "#0F23DF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPruff9);
export default __webpack_public_path__ + "static/media/pruff9.6f20e3c585542475917557774e02aadc.svg";
export { ForwardRef as ReactComponent };